(function () {
  'use strict';
  var parameter = 'nytarp_return';
  var productPath = /^\/products\/[a-z0-9][a-z0-9-]*$/;
  function returnUrl(value) {
    // Only a relative canonical product path and a numeric variant are accepted.
    if (!value || value.length > 700 || value !== value.trim() || value.charAt(0) !== '/' || value.slice(0, 2) === '//') return null;
    try {
      var url = new URL(value, location.origin);
      if (url.origin !== location.origin || !productPath.test(url.pathname) || url.hash || value.split('?')[0] !== url.pathname) return null;
      var allowed = true;
      url.searchParams.forEach(function (entry, key) {
        if ((key !== 'variant' && key !== 'preview_theme_id') || url.searchParams.getAll(key).length !== 1) allowed = false;
      });
      if (!allowed) return null;
      var variant = url.searchParams.get('variant');
      if (!variant || !/^\d{1,20}$/.test(variant)) return null;
      var clean = new URL(url.pathname, location.origin);
      clean.searchParams.set('variant', variant);
      var preview = url.searchParams.get('preview_theme_id');
      if (url.searchParams.has('preview_theme_id')) {
        if (!/^\d{1,20}$/.test(preview || '')) return null;
        clean.searchParams.set('preview_theme_id', preview);
      }
      return clean;
    } catch (error) { return null; }
  }
  var product = document.querySelector('[data-section-type="product"]');
  if (product) {
    function decorate(link) {
      if (!link || !link.href) return;
      var target;
      try { target = new URL(link.href, location.origin); } catch (error) { return; }
      var guide = /^\/blogs\/guides\/[a-z0-9-]+$/.test(target.pathname);
      var inquiry = link.hasAttribute('data-nytarp-inquiry-link') && target.pathname === '/pages/contact-us';
      if (target.origin !== location.origin || (!guide && !inquiry)) return;
      var input = product.querySelector('form[action="/cart/add"] [name="id"]');
      var variant = input && input.value;
      // URL history and the form may update independently; the form is authoritative.
      if (!variant || !/^\d{1,20}$/.test(variant)) return;
      var path = '/products/' + product.getAttribute('data-generated-product-handle');
      if (!productPath.test(path)) return;
      var source = new URL(path, location.origin);
      source.searchParams.set('variant', variant);
      var preview = new URL(location.href).searchParams.get('preview_theme_id');
      if (preview && /^\d{1,20}$/.test(preview)) source.searchParams.set('preview_theme_id', preview);
      if (inquiry && preview && /^\d{1,20}$/.test(preview)) target.searchParams.set('preview_theme_id', preview);
      target.searchParams.set(parameter, source.pathname + source.search);
      link.href = target.pathname + target.search + target.hash;
    }
    function decorateAll() { document.querySelectorAll('a[href*="/blogs/guides/"], a[data-nytarp-inquiry-link]').forEach(decorate); }
    decorateAll();
    // Refresh just before activation, including keyboard and open-in-new-tab use.
    ['pointerdown', 'focusin', 'click', 'contextmenu'].forEach(function (name) {
      document.addEventListener(name, function (event) { decorate(event.target.closest && event.target.closest('a')); }, true);
    });
    product.addEventListener('change', function () { window.setTimeout(decorateAll, 0); });
  } else {
    var params = new URL(location.href).searchParams;
    var source = params.getAll(parameter).length === 1 ? returnUrl(params.get(parameter)) : null;
    var nav = document.querySelector('[data-nytarp-return-nav]');
    var back = nav && nav.querySelector('[data-nytarp-return-link]');
    if (!source || !back) return;
    back.href = source.pathname + source.search;
    nav.hidden = false;
    var context = document.querySelector('[data-nytarp-inquiry-context]');
    if (context) {
      var productLink = context.querySelector('[data-nytarp-inquiry-product]');
      var productUrl = context.querySelector('[data-nytarp-inquiry-url]');
      if (productLink && productUrl) {
        productLink.href = source.pathname + source.search;
        // Show a shareable public product URL, without a draft theme identifier.
        var publicSource = new URL(source.pathname, location.origin);
        publicSource.searchParams.set('variant', source.searchParams.get('variant'));
        productUrl.textContent = publicSource.href;
        context.hidden = false;
      }
    }
    // The explicit return link is always present. Any existing link to this same
    // product also keeps the selected variant; unrelated product links stay intact.
    document.querySelectorAll('a[href*="/products/"]').forEach(function (link) {
      try {
        var target = new URL(link.href, location.origin);
        if (target.origin === source.origin && target.pathname === source.pathname) {
          target.searchParams.set('variant', source.searchParams.get('variant'));
          link.href = target.pathname + target.search + target.hash;
        }
      } catch (error) { /* Ignore invalid source links. */ }
    });
  }
}());
